module.exports = __webpack_public_path__ + "media/images/icon_job_category1-f784ea7405c9052b0cb9f31307586e91.png";